import React, { useState } from 'react';
import {
  ButtonBase,
  Fade,
  TextFieldProps,
  Tooltip,
  Typography,
  TypographyProps,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { TPTextField } from '.';

interface EditableTextWithTextFieldProps {
  label: string;
  typographyProps?: TypographyProps;
  textFieldProps?: TextFieldProps;
  onSubmit: (editText: string) => void;
}

const EditableTextWithTextField: React.FC<EditableTextWithTextFieldProps> = ({
  label,
  typographyProps = {},
  textFieldProps = {},
  onSubmit,
}) => {
  // State
  const [editText, setEditText] = useState('');
  const [editMode, setEditMode] = useState(false);

  const openEditMode = () => {
    setEditMode(true);
    setEditText(label);
  };

  const closeEditMode = () => {
    setEditMode(false);
    setEditText('');
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    setEditText(value);
  };

  const handleSubmit = () => {
    if (editText !== label && editText) {
      onSubmit(editText);
    }

    closeEditMode();
  };

  if (editMode) {
    return (
      <Fade in>
        <TPTextField
          size="small"
          autoFocus
          fullWidth
          value={editText}
          onChange={handleInputChange}
          onBlur={handleSubmit}
          {...textFieldProps}
        />
      </Fade>
    );
  }

  return (
    <Typography maxWidth="calc(100% - 20px)" display="flex" alignItems="center">
      <Typography {...typographyProps}>{label}</Typography>
      &nbsp;
      <Tooltip title="Edit" placement="top">
        <ButtonBase
          onClick={openEditMode}
          sx={{ position: 'relative', right: 0 }}
        >
          <EditIcon fontSize="small" />
        </ButtonBase>
      </Tooltip>
    </Typography>
  );
};

export default EditableTextWithTextField;
